// Garde les champs authenticity_token alignés sur la meta après Turbolinks / connexion.
const csrfTokenFromMeta = () =>
  document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")

const syncAuthenticityTokenFields = () => {
  const token = csrfTokenFromMeta()
  if (!token) return

  document.querySelectorAll('input[name="authenticity_token"]').forEach((input) => {
    input.value = token
  })
}

const initCsrfSync = () => {
  document.addEventListener("turbolinks:load", syncAuthenticityTokenFields)
  document.addEventListener("turbolinks:before-cache", syncAuthenticityTokenFields)
}

export { initCsrfSync, syncAuthenticityTokenFields }
